import {
  AutopilotTaskDto,
  TaskCategoryWorkflowType,
} from '@urbanx/agx.activities.client'
import { Pages } from 'constants/menu'
import { TaskTabs } from 'components/tasks/Tasks'
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

export const useNavigateToTask = () => {
  const navigate = useNavigate()

  const navigateToTask = useCallback(
    (task: AutopilotTaskDto) => {
      if (!task) return

      const { campaignId, contractId, category, agencyId } = task

      const isContractTask = !!task.campaignId && !!task.contractId

      if (!agencyId || !campaignId) return
      let tab: TaskTabs = TaskTabs.Tasks
      let navigateTo: string = ''
      if (isContractTask) {
        tab =
          category?.workflowType ===
            TaskCategoryWorkflowType.IndependentCampaign ||
            category?.workflowType ===
            TaskCategoryWorkflowType.IndependentContract
            ? TaskTabs.Other
            : TaskTabs.Tasks
        switch (category?.workflowType) {
          case TaskCategoryWorkflowType.IndependentCampaign:
          case TaskCategoryWorkflowType.IndependentContract: {
            tab = TaskTabs.Tasks
            break
          }
          case TaskCategoryWorkflowType.Deposit: {
            tab = TaskTabs.Deposits
            break
          }
          default: {
            tab = TaskTabs.Tasks
          }
        }

        navigateTo = `/${Pages.AGENCIES}/${agencyId}/${Pages.CAMPAIGNS}/${campaignId}/${Pages.CONTRACTS}/${contractId}/${Pages.CONTRACT_TASKS}${category?.workflowType ? `#tab=${tab}` : ''}`
      } else {
        tab =
          category?.workflowType ===
            TaskCategoryWorkflowType.IndependentCampaign ||
            category?.workflowType ===
            TaskCategoryWorkflowType.IndependentContract
            ? TaskTabs.Other
            : TaskTabs.Tasks

        navigateTo = `/${Pages.AGENCIES}/${agencyId}/${Pages.CAMPAIGNS}/${campaignId}/${Pages.CAMPAIGN_TASKS}${category?.workflowType ? `#tab=${tab}` : ''}`
      }

      navigate(navigateTo)
    },
    [navigate]
  )

  return navigateToTask
}
